import { axiosRequest } from '../../axiosRequest';
import {
	AUDIENCE_TYPES,
	normalizeRecipientStats,
} from 'helpers/notificationDelivery';

import moment from 'moment';

const adapterAppResponse = ({ data, success }) => {
	if (success === false) return { error: true, data };

	const notification = data?.notification ? {
		id: data?.notification?.id,
		title: data?.notification?.title,
		message: data?.notification?.message,
		audience: data?.notification?.audience,
		audience_type: data?.notification?.audience_type || AUDIENCE_TYPES.VENUES,
		total_recipients: data?.notification?.total_recipients ?? 0,
		// Full breakdown per recipient status; all zeros (total = 0) for
		// notifications sent before per-recipient tracking.
		stats: normalizeRecipientStats(data?.notification?.stats),
		status: data?.notification?.status,
		sent_at:
			data?.notification?.sent_at && moment(data?.notification?.sent_at, 'YYYY-MM-DD').format('MM/DD/YYYY'),
		// Raw ISO date, to display it with the time.
		sent_at_iso: data?.notification?.sent_at || null,
		created_at:
			data?.notification?.created_at &&
			moment(data?.notification?.created_at, 'YYYY-MM-DD').format('MM/DD/YYYY'),
		updated_at:
			data?.notification?.updated_at &&
			moment(data?.notification?.updated_at, 'YYYY-MM-DD').format('MM/DD/YYYY'),
		admin: {
			id: data?.notification?.admin?.id,
			full_name: data?.notification?.admin?.full_name,
		},
	} : null;

	return notification;
};

export const getNotification = async (id) => {
	var options = {
		method: 'get',
		url: `dashboard/notifications/${id}`,
	};

	const response = await axiosRequest(options);

	const notification = adapterAppResponse(response);

	return notification;
};
